import {
  FETCH_CARS,
  FETCH_CARS_SUCCESS,
  FETCH_CARS_FAILED,
  EDIT_CAR,
} from "../store/types";
import store from "../store/store";
import { getSupabase } from "../config/configureSupabase";
import { uploadMedia } from "../other/supabaseStorage";

export const fetchCars = () => async (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    dispatch({
      type: FETCH_CARS,
      payload: null,
    });
    try {
      const userInfo = store.getState().auth?.profile;
      let query = supabase.from("vehicles").select("*");
      if (userInfo?.tenant_id) {
        query = query.eq("tenant_id", userInfo.tenant_id);
      }
      const { data, error } = await query;
      if (!error && data) {
        const mapped = data.map((v) => ({
          ...v,
          vehicleNumber: v.plate,
          vehicleMake: v.make,
          vehicleModel: v.model,
          carType: v.model,
        }));
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: mapped,
        });
        return;
      }
    } catch (e) {
      console.warn("fetchCars supabase error:", e);
    }
  }

  dispatch({
    type: FETCH_CARS_FAILED,
    payload:
      store.getState().languagedata?.defaultLanguage?.no_cars || "Sem veículos",
  });
};

export const editCar = (car, method) => async (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    dispatch({
      type: EDIT_CAR,
      payload: { method, car },
    });
    const profile = store.getState().auth?.profile;
    const vehicleRecord = {
      plate: car.vehicleNumber || car.plate,
      make: car.vehicleMake || car.make || "",
      model: car.vehicleModel || car.model || car.carType || "",
      year: parseInt(car.year || new Date().getFullYear(), 10),
      status: car.status || "available",
      tenant_id: car.tenant_id || profile?.tenant_id,
    };
    if (Object.prototype.hasOwnProperty.call(car, "car_image")) {
      vehicleRecord.car_image = car.car_image;
    }

    if (method === "Add") {
      await supabase.from("vehicles").insert([vehicleRecord]);
    } else if (method === "Delete") {
      await supabase.from("vehicles").delete().eq("id", car.id);
    } else {
      await supabase.from("vehicles").update(vehicleRecord).eq("id", car.id);
    }
    dispatch(fetchCars());
  }
};

export const updateUserCarWithImage = (newData, blob) => async (dispatch) => {
  if (!newData || !blob) return;
  const carId = newData.id || "car_" + Date.now();
  const publicUrl = await uploadMedia(
    "media",
    `vehicles/${carId}.jpg`,
    blob,
    "image/jpeg",
  );
  if (publicUrl) {
    newData.car_image = publicUrl;
    dispatch(editCar(newData, newData.id ? "Edit" : "Add"));
  }
};
